export default ({ COLORS }) => ({
  container: {
    margin: '0 15px 15px 0',
    minWidth: '15%',
    width: '190px'
  },
  order0: {
    borderColor: COLORS.SUPPORTING.YEAR0.NORMAL,
    backgroundColor: COLORS.SUPPORTING.YEAR0.EXTRA_FADED
  },
  order1: {
    borderColor: COLORS.SUPPORTING.YEAR1.NORMAL,
    backgroundColor: COLORS.SUPPORTING.YEAR1.EXTRA_FADED
  },
  order2: {
    borderColor: COLORS.SUPPORTING.YEAR2.NORMAL,
    backgroundColor: COLORS.SUPPORTING.YEAR2.EXTRA_FADED
  },
  order3: {
    borderColor: COLORS.SUPPORTING.YEAR3.NORMAL,
    backgroundColor: COLORS.SUPPORTING.YEAR3.EXTRA_FADED
  },
  order4: {
    borderColor: COLORS.SUPPORTING.YEAR4.NORMAL,
    backgroundColor: COLORS.SUPPORTING.YEAR4.EXTRA_FADED
  },
  order5: {
    borderColor: COLORS.SUPPORTING.YEAR5.NORMAL,
    backgroundColor: COLORS.SUPPORTING.YEAR5.EXTRA_FADED
  },
  order6: {
    borderColor: COLORS.SUPPORTING.YEAR6.NORMAL,
    backgroundColor: COLORS.SUPPORTING.YEAR6.EXTRA_FADED
  },
  order7: {
    borderColor: COLORS.SUPPORTING.YEAR7.NORMAL,
    backgroundColor: COLORS.SUPPORTING.YEAR7.EXTRA_FADED
  },
  order8: {
    borderColor: COLORS.SUPPORTING.YEAR8.NORMAL,
    backgroundColor: COLORS.SUPPORTING.YEAR8.EXTRA_FADED
  },
  order9: {
    borderColor: COLORS.SUPPORTING.YEAR9.NORMAL,
    backgroundColor: COLORS.SUPPORTING.YEAR9.EXTRA_FADED
  },
  order10: {
    borderColor: COLORS.SUPPORTING.YEAR10.NORMAL,
    backgroundColor: COLORS.SUPPORTING.YEAR10.EXTRA_FADED
  },
  order11: {
    borderColor: COLORS.SUPPORTING.YEAR11.NORMAL,
    backgroundColor: COLORS.SUPPORTING.YEAR11.EXTRA_FADED
  },
  order12: {
    borderColor: COLORS.SUPPORTING.YEAR12.NORMAL,
    backgroundColor: COLORS.SUPPORTING.YEAR12.EXTRA_FADED
  },
  order13: {
    borderColor: COLORS.SUPPORTING.YEAR13.NORMAL,
    backgroundColor: '#e1f19a'
  },
  order14: {
    borderColor: COLORS.SUPPORTING.YEAR14.NORMAL,
    backgroundColor: COLORS.SUPPORTING.YEAR14.EXTRA_FADED
  },
  order15: {
    borderColor: COLORS.RED.FADED,
    backgroundColor: COLORS.RED.EXTRA_FADED
  },
  title: {
    margin: '20px 0 0',
    fontSize: '16px',
    lineHeight: '1'
  },
  thumb: {
    borderRadius: '16px',

    padding: '26px 26px 26px 30px',
    width: '100%',
    height: '268px',
    position: 'relative'
  },
  book: {
    background: 'rgba(255,255,255,0.5)',
    width: '100%',
    height: '100%',
    boxShadow: '-5px 5px 5px rgb(0 0 0 / 20%)',
    borderRadius: '2px',
    padding: '16px'
  },
  link: {
    textDecoration: 'none',
    color: '#333',
    '&:hover > div > div': {
      transform: 'scale(1.05)',
      transition: 'transform 200ms ease-in-out'
    }
  },
  bookTitle: {
    fontWeight: 'bold',
    fontSize: '16px'
  },
  bookArrow: {
    width: '50px',
    height: '50px',
    background: 'rgba(255,255,255,0.8)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    padding: '10px',
    color: 'rgba(0,0,0,0.3)',
    borderRadius: '100%',
    margin: '30px 0',
    fontSize: '24px'
  },
  crown: {
    background: COLORS.DARK_BLUE.NORMAL,
    fontSize: '34px',
    position: 'absolute',
    right: '-13px',
    top: '-12px',
    borderRadius: '100%',
    padding: '5px',
    height: '30px',
    width: '30px !important'
  },
  working_towards_the_expected_standard: {
    transform: 'rotate(45deg)'
  },
  greater_depth_within_the_expected_standard: {
    transform: 'rotate(-45deg)'
  },
  working_at_the_expected_standard: {},
  copyBtn: {
    margin: '10px 5px 0px 10px',
    minWidth: '80%'
  },
  info: {
    opacity: 0.5
  }
})
